<template>
  <div class="order"
       style="background:rgb(249 249 249);">

    <van-cell-group inset
                    v-for="(item,i) in list0"
                    :key="i"
                    style="width: 100%; margin-left: 0%; margin-bottom: 10px;">
      <van-cell title="房产信息"
                :value="item.areaName+'-'+item.villageName"
                :label="item.detailAddress"
                is-link />
      <van-cell title="申请时间"
                :value="item.createTime" />
      <van-cell title="申请网点"
                :value="item.deptName" />
    </van-cell-group>
    <van-empty v-if="list0.length<=0"
               description="暂无待受理的申请" />

  </div>
</template>

<script>
import { getLoadList } from '@/api/public'

export default {
  name: 'order',
  data () {
    return {
      tabsActive: '0',
      tabbarActive: 'order',
      list0: [],
      list1: [],
      list2: [],
    };
  },
  created () {
    this.$store.state.tabBar = this.$route.name;
    this.loadLog(0);
  },
  methods: {
    change (name) {
      this.loadLog(name);
    },
    loadLog (query) {
      getLoadList(query).then((res) => {
        this['list' + query] = res.data;
        res.data.forEach(e => {
          e.active = true;
        });
      }).catch(e => {
        console.log(e);
      })
    },
    cellClick (index, list) {
      list.forEach((item, i) => {
        if (i == index) {
          list[index].active = !list[index].active;
        } else {
          item.active = false;
        }
      })
    }
  },
}
</script>
<style lang="less">
.order-tabs {
  .van-tabs__content {
    min-height: 100vh;
  }
}
</style>
